export default __webpack_public_path__ + "static/media/events.74554a5f.svg";